import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import styles from './ItemRule.css';
import Select from '../Select';

class ItemInput extends Component {
  render() {
    const {
      items,
      itemVariants,
      itemIndex,
      earningRuleItem,
      buildOptions,
      onChangeItem,
      onChangeItemVariant,
      removeItem,
    } = this.props;
    return (
      <div className={`well ${styles.well}`}>
        <div className="col-sm-11 bottom10 no-padding">
          <Select
            options={buildOptions(items)}
            disabled={_.isEmpty(items)}
            value={earningRuleItem.item_name}
            placeholder="Search Items"
            onChange={onChangeItem}
          />
        </div>
        <div className={`col-sm-1 bottom10 ${styles.remove}`}>
          <i
            className={`fa fa-times-circle fa-lg ${styles['x-button']}`}
            onClick={() => removeItem(itemIndex)}
          />
        </div>
        <div className="col-sm-11 bottom10 no-padding">
          <Select
            options={buildOptions(itemVariants[earningRuleItem.item_name])}
            disabled={false}
            value={earningRuleItem.item_variant_names}
            placeholder="Add Variants"
            onChange={onChangeItemVariant}
            closeOnSelect={false}
            multi
            allowSelectAll
            allOption={{
              label:
                'All Variants (including new variants added in the future)',
              value: '*',
            }}
          />
        </div>
      </div>
    );
  }
}

ItemInput.propTypes = {
  items: PropTypes.array.isRequired,
  buildOptions: PropTypes.func.isRequired,
  earningRuleItem: PropTypes.object.isRequired,
  itemVariants: PropTypes.array.isRequired,
  onChangeItem: PropTypes.func.isRequired,
  onChangeItemVariant: PropTypes.func.isRequired,
};

export default ItemInput;
